// @flow
import immutable, { Record } from "immutable"

import { departureArrivalFromJS, getDuration } from "./Flight"
import { showDate, isLocalOverNight } from "../../../app/scripts/containers/helpers/partHelper"

export default class Transfer extends Record({
  // Common with Flight
  id: null,
  departure: null,
  arrival: null,
  vehicle: null,
  type: null, // bus|train

  carrier: null, // called airline in Flight

  // Special for Transfer
  flightIndex: null,
}) {
  getDuration() {
    // Ugly fix when utc time format not available
    const timeFormat = !this.get("arrival")
      .get("when")
      .get("utc")
      .isValid()
      ? "local"
      : "utc"

    return getDuration(
      this.getIn(["arrival", "when", timeFormat]),
      this.getIn(["departure", "when", timeFormat]),
    )
  }

  // eslint-disable-next-line
  getFlightNumber() {
    return null
  }

  // We should manage transfer and flight subclasses that should extend more general part container soon
  // eslint-disable-next-line
  hasDifferentOperatingAirline() {
    return false
  }

  isLocalOverNight(): boolean {
    return isLocalOverNight(this)
  }

  showDate(prevPart: Transfer): boolean {
    return showDate(prevPart, this)
  }

  static fromPlainJS(input: any) {
    return new Transfer({
      id: input.id,
      departure: departureArrivalFromJS(input.departure),
      arrival: departureArrivalFromJS(input.arrival),
      vehicle: input.vehicle && immutable.fromJS(input.vehicle),
      carrier: immutable.fromJS(input.carrier),
      flightIndex: immutable.fromJS(input.flightIndex),
      type: immutable.fromJS(input.type),
    })
  }
}
